import { createSlice } from '@reduxjs/toolkit';
import { BaseApiState } from '../../api/axiosConfig';
import {
  ExaminationResult,
  ExaminationStatusResponse,
} from '../../api/maintestApi';
import { handlePending, handleReject } from '../../utils/redux';
import {
  getExaminationId,
  getExaminationResult,
  getExaminationStatus,
  postEmailSending,
} from './thunks';

export interface ExaminationState extends BaseApiState {
  examinationID: string;
  answers: string[];
  succeededMail: boolean;
  finished: boolean;
  examinationStatus?: ExaminationStatusResponse;
  remainingResends: number;
  examinationResult?: ExaminationResult;
  examinationResultStatus: boolean;
}
const initialState: ExaminationState = {
  examinationID: '',
  answers: [],
  examinationStatus: undefined,
  succeeded: false,
  succeededMail: false,
  remainingResends: 3,
  examinationResult: undefined,
  examinationResultStatus: false,
  finished: false,
  loading: false,
  error: false,
  errorMessage: '',
  errorDetails: {},
};

export const examinationSlice = createSlice({
  name: 'examination',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExaminationId.pending, handlePending)
      .addCase(getExaminationId.fulfilled, (state, action) => {
        state.examinationID = action.payload.id ?? '';
        state.succeeded = true;
        state.loading = false;
      })
      .addCase(getExaminationId.rejected, handleReject)
      .addCase(getExaminationStatus.pending, handlePending)
      .addCase(getExaminationStatus.fulfilled, (state, action) => {
        state.examinationStatus = action.payload.status ?? '';
        state.succeeded = true;
        state.loading = false;
      })
      .addCase(getExaminationStatus.rejected, handleReject)
      .addCase(postEmailSending.rejected, (state) => {
        state.loading = false;
        state.succeededMail = false;
        state.finished = true;
      })
      .addCase(postEmailSending.fulfilled, (state, action) => {
        state.succeededMail = true;
        state.loading = false;
        state.finished = true;
        state.remainingResends = action.payload.RemainingResends;
      })
      .addCase(postEmailSending.pending, (state) => {
        handlePending;
        state.finished = false;
      })
      .addCase(getExaminationResult.pending, (state) => {
        handlePending;
        state.examinationResultStatus = false;
      })
      .addCase(getExaminationResult.fulfilled, (state, action) => {
        state.examinationResult = action.payload ?? '';
        state.examinationResultStatus = true;
      })
      .addCase(getExaminationResult.rejected, (state) => {
        handleReject;
        state.examinationResultStatus = false;
      });
  },
});

export const examinationReducer = examinationSlice.reducer;
